import React, { useRef, useEffect, useState } from 'react';
import { mount } from 'redom';

import { HexColorPicker } from 'react-colorful';

import VariablesDisplayControl from 'root/startup-view/campaigns/right-panel/editor-panel/editor/variables-display-control';

import PrefixedInput from '../color-picker-native/input';

import './index.scss';

const variables = [{
  path: '{p}',
  description: 'Primary color'
}, {
  path: '{s}',
  description: 'Secondary color'
}, {
  path: '{t}',
  description: 'Tertiary color'
}, {
  path: '{b}',
  description: 'Primary background color'
}, {
  path: '{sb}',
  description: 'Secondary background color'
}, {
  path: '{tt}',
  description: 'Text color'
}];

function HelptapColorPicker(props) {

  const mainReference = useRef(null);
  const prefixedInputReference = useRef(null);

  const [rootState, setRootState] = useState({
    color: props.color
  });

  useEffect(function onLoad() {

    if (prefixedInputReference.current !== null) {
      return;
    }

    const variablesDisplayControl = new VariablesDisplayControl({
      title: 'CSS color variables available in color pickers',
      variables
    });

    mount(mainReference.current, variablesDisplayControl);

    prefixedInputReference.current = new PrefixedInput({
      value: rootState.color,
      onChange: setColor
    });

    mount(mainReference.current, prefixedInputReference.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setColor(color) {
    props.onChange(color);
    setRootState(function updateRootState(rootState) {

      return {
        ...rootState,
        color
      };

    });

  }

  function renderMain() {

    const color = rootState.color;

    const colorPickerAttributes = {
      color: PrefixedInput.tryConvertToHexCode(color),
      onChange(color) {
        prefixedInputReference.current.setValue(color);
        setColor(color);
      }
    };

    const inputSectionAttributes = {
      ref: mainReference,
      className: 'helptap-color-picker-input-section'
    };

    return <div className="helptap-color-picker-main editor-tool-container">
      <HexColorPicker {...colorPickerAttributes} />
      <div {...inputSectionAttributes}>
      </div>
    </div>;

  }

  return renderMain();

}

export default HelptapColorPicker;